import React from 'react';
import { loginGoogle } from '../Helpers/Login_helper.js';

import claveUnica from '../assets/img/login/claveunica.svg';
import ilustracionLogin from '../assets/img/login/ilustracion_login.png';

import { GoogleOAuthProvider } from '@react-oauth/google';
import { GoogleLogin } from '@react-oauth/google';
import jwt_decode from "jwt-decode";

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const Login = ({ history, setStateSesion }) => {

    const handleLoginGoogle = (respuesta) => {
        let google_jwt = respuesta["credential"];
        google_jwt = jwt_decode(google_jwt);
        var email = google_jwt["email"];
        const data_loginGoogle = loginGoogle(email);
        data_loginGoogle.then(respuesta => {
            if(respuesta?.success)
            {
                setStateSesion(true);
                history.replace('/Contenido');
            }
        })
    }

    return(
        <>
            <nav className="nav-login">
                <div className="div-presentacion-cnr gradiente">
                    <span className="presentacion-cnr">CNR</span>
                </div>
            </nav>
            <section className="hero-section-login">
                <div className="contenedor-login-hero">
                    <h1 className="h1-login">Gestión Iniciativas Inversión</h1>
                    <p className="p-login">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolore maxime enim libero,
                        unde sequi quidem aspernatur ea ex asperiores magnam esse, dignissimos quia nam perspiciatis
                        cupiditate vero nesciunt ducimus eum.
                    </p>
                    <Container className='mt-5'>
                        <Row>
                            <Col>
                                <button className="btn-clave-unica shadow">
                                    <img src={claveUnica} alt="icono clave unica" className="me-2 mb-1" height="19" width="19"/>
                                    Ingresar con Clave Unica
                                </button>
                            </Col>
                            <Col>
                                <GoogleOAuthProvider clientId="811223902632-qo5tkhtgiqaeggl4tqi5h3iqhjggea4q.apps.googleusercontent.com">
                                    <GoogleLogin
                                        onSuccess={credentialResponse => {
                                            handleLoginGoogle(credentialResponse)
                                        }}
                                        onError={() => {
                                            console.log('Login Failed');
                                        }}
                                        useOneTap
                                        size='large'
                                        shape='circle'
                                        theme='outline'
                                    />
                                </GoogleOAuthProvider>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <img src={ilustracionLogin} alt="ilustracion login" className="ilustracion-login"/>
            </section>
        </>
    )
}

export default Login;